import { useRef } from 'react';

export function useFirstRender(): boolean {
  const renderRef = useRef(true);

  if (renderRef.current) {
    renderRef.current = false;

    return true;
  }

  return false;
}
